export default {
    setDeckList(state, payload) {
        for (const index in payload) {
            payload[index] = {
                ...payload[index],
                showAnswers: false
            }

            for (const feedListindex in payload[index].feedList) {
                payload[index].feedList[feedListindex] = { 
                    ...payload[index].feedList[feedListindex], 
                    idCopyIconName: "file_copy",
                    answers: []
                }
            }
        }

        state.sniffdeck = payload;
    },
    pushSingleDeckList(state, payload) {
        for (const index in payload.feedList) {
            payload.feedList[index] = { 
                ...payload.feedList[index], 
                idCopyIconName: "file_copy",
                answers: []
            }
        }

        const selectedDeck = state.sniffdeck.find(x => x.id == payload.id);

        if (selectedDeck) {
            const mergedList = [...selectedDeck.feedList, ...payload.feedList];

            selectedDeck.feedList = mergedList;
        }
    },
    setSingleDeckList(state, payload) {
        for (const index in payload.feedList) {
            payload.feedList[index] = { 
                ...payload.feedList[index], 
                idCopyIconName: "file_copy"
            }
        }

        const selectedDeck = state.sniffdeck.find(x => x.id == payload.id);

        if (selectedDeck) {
            selectedDeck.feedList = payload.feedList;
            selectedDeck.filter = payload.filter;
        }
    },
    setNewDeck(state, payload) {
        payload = {
            ...payload,
            showAnswers: false
        }

        for (const index in payload.feedList) {
            payload.feedList[index] = { 
                ...payload.feedList[index], 
                idCopyIconName: "file_copy"
            }
        }

        state.sniffdeck.push(payload);
    },
    setMentionSuggestions(state, payload) {
        state.mentionSuggestions = payload.mentionsuggestions;
    },
    deleteDeck(state, payload) {
        const removedDeck = state.sniffdeck.find(x => x.id == payload);
        const indexOfRemoved = state.sniffdeck.indexOf(removedDeck);

        if (indexOfRemoved >= 0) {
            state.sniffdeck.splice(indexOfRemoved, 1);
        }
    },
    setDeckFeedAnswers(state, payload) {
        const sniffdeck = state.sniffdeck.find(x => x.id == payload.deckId);

        if (sniffdeck) {
            const deckFeed = sniffdeck.feedList.find(x => x.id == payload.feedId);

            if (deckFeed) {
                deckFeed.answers = payload.answers;
            }
        }
    },
    showFeedAnswers(state, payload) {
        const sniffdeck = state.sniffdeck.find(x => x.id == payload);

        if (sniffdeck) {
            sniffdeck.showAnswers = true;
        }
    },
    hideFeedAnswers(state, payload) {
        const sniffdeck = state.sniffdeck.find(x => x.id == payload);

        if (sniffdeck) {
            sniffdeck.showAnswers = false;
        }
    },
    setSentiment(state, payload) {
        const sniffdeck = state.sniffdeck.find(x => x.id == payload.deckId);

        if (sniffdeck) {
            const deckFeed = sniffdeck.feedList.find(x => x.id == payload.feedId);

            if (deckFeed) {
                deckFeed.sentimentId = payload.sentimentId;
            }
        }
    },
    setUserFeedHistory(state, payload) {
        for (const index in payload) {
            payload[index] = { ...payload[index], showResponse: false }
        }

        state.userFeedHistoryList = payload;
    },
    setUserFeedHistoryAnswers(state, payload) {
        const feed = state.userFeedHistoryList.find(f => f.id == payload.feedId);

        if (feed) {
            feed.answers = payload.answers;
        }
    },
    setSettingLanguages(state, payload) {
        state.settingLanguageList = payload
    },
}